import type { FC, MouseEvent, ReactElement } from 'react';

import { useAudioTrigger } from '../../../../controllers/audioController/hooks';
import { useModifiers } from '../../../../styles/hooks/useModifiers';
import { ChipConnected } from '../../chip/ChipConnected';
import type { ChipStackButtonProps } from '../types';

import styles from './chipStackButton.module.css';

export const ChipStackButton: FC<ChipStackButtonProps> = ({
  active,
  chip,
  disabled,
  fidget,
  grow,
  onChipSelect,
  onClick,
  small,
  ...rest
}): ReactElement => {
  const audioTrigger = useAudioTrigger();
  const handleChipClick = (event: MouseEvent<HTMLButtonElement>): void => {
    if (!disabled) {
      audioTrigger.play({ name: 'chipClick' });
      onChipSelect(chip);
      onClick?.(event);
    }
  };

  const mods = useModifiers(styles, 'chipStackButton', { active, disabled, fidget, grow, small });
  return (
    <button
      data-testid={`chip-stack-value-${chip.value}`}
      className={`${styles.chipStackButton} ${mods}`}
      disabled={disabled}
      key={chip.weight}
      onClick={handleChipClick}
      type="button"
      {...rest}
    >
      <span className={styles.chipStackButton__chipContainer}>
        <span className={styles.chipStackButton__chip}>
          <ChipConnected size="inherit" value={chip.value} weight={chip.weight} />
        </span>
      </span>
    </button>
  );
};
